<template>
  <div class="loading-overlay">
    <div class="loading-content">
      <img
        src="~/assets/images/compare/icon_loader.gif"
        width="100"
        height="100"
        class="icon"
      />
      <span>読み込み中・・・</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.loading-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.loading-content {
  padding: 8% 0;
  border-radius: 5px;
  width: 94%;
  background-color: #fff;
  text-align: center;

  img {
    margin: 0 auto 4%;
    width: 56px;
    height: 56px;
  }

  span {
    color: #0092d2;
    font-size: px(20);
  }
}

@include media(pc) {
  .loading-content {
    padding: 64px 0;
    width: 560px;

    img {
      margin: 0 auto 4%;
      width: 100px;
      height: 100px;
    }

    span {
      font-size: px(20);
    }
  }
}
</style>
